var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "token-branded:usdc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37974 3L13.9214 5.06706V14.9329L9.37974 17L7.69922 16.0052V3.99477L9.37974 3ZM9.13843 3.71486L8.52655 4.07659L9.13843 4.29622V3.71486ZM9.13843 4.81729L8.21199 4.48139V15.5186L9.13843 15.1827V4.81729ZM9.6512 14.9975V5.00246L11.9479 5.83359V14.1664L9.6512 14.9975ZM9.13843 15.7038L8.52655 15.9234L9.13843 16.2851V15.7038ZM9.6512 16.3411V15.5186L12.2108 14.5927L12.9778 14.8296L9.6512 16.3454V16.3411ZM13.4087 14.4506L12.4607 14.1578V5.84651L13.4087 5.55798V14.4506ZM12.9778 5.17902L12.2108 5.41157L9.6512 4.4857V3.66318L12.9735 5.17472L12.9778 5.17902Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgi);
export default __webpack_public_path__ + "static/media/agi.606737f2e425601900ea244b07b17c6a.svg";
export { ForwardRef as ReactComponent };